import { jsx as _jsx } from "react/jsx-runtime";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Accordion, AccordionDetails, AccordionSummary, accordionSummaryClasses, styled } from '@mui/material';
export const IoTVAccordion = styled((props) => _jsx(Accordion, { disableGutters: true, ...props }))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));
export const IoTVAccordionSummary = styled((props) => (_jsx(AccordionSummary, { expandIcon: _jsx(ArrowForwardIosIcon, { sx: { fontSize: '0.9rem' } }), ...props })))(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]: {
        transform: 'rotate(90deg)',
    },
    [`& .${accordionSummaryClasses.content}`]: {
        marginLeft: theme.spacing(1),
    },
}));
export const IoTVAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
    borderTop: '1px solid rgba(0, 0, 0, .125)',
    padding: theme.spacing(1),
}));
